import type { AssistantAccountSummaryData } from "@/types/assistant";

export function getAssistantResourceSummaryQueryKey() {
  return ["assistant-data", "account", "summary"];
}

export function useAssistantAccountSummaryRequest() {
  const { setCachedData, maybeGetFromCacheAndRefetch } = useApiCache();
  const enabled = computed(() => !!currentSessionInformation.appAuthToken);
  const query = useQuery({
    queryKey: getAssistantResourceSummaryQueryKey(),
    queryFn: async () => {
      const { cachedData, isInitialized } = maybeGetFromCacheAndRefetch(
        "accountSummary",
        getAssistantResourceSummaryQueryKey()
      );
      if (cachedData && !isInitialized) return cachedData;
      const { data } = await useGetRequest<AssistantAccountSummaryData>(
        "/account/data/summary"
      );
      if (data) {
        setCachedData("accountSummary", data);
      }
      return data;
    },
    enabled,
    staleTime: 5 * MINUTE,
  });

  return query;
}
